import { useQuery, UseQueryResult } from '@tanstack/react-query';

import {
  getZeePersonaData,
  GetZeePersonaDataApiResponse,
} from '@/actions/zee-persona-data/getZeePersonaData';
import { ApiResponse } from '@/types/response.type';

export interface UseGetZeePersonaDataReturn {
  result: ApiResponse<GetZeePersonaDataApiResponse> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetZeePersonaData = (
  userId: string,
  zorId: string
): UseGetZeePersonaDataReturn => {
  const query: UseQueryResult<
    ApiResponse<GetZeePersonaDataApiResponse> | undefined,
    Error
  > = useQuery({
    queryKey: ['zee-persona-data', userId, zorId],
    queryFn: () => getZeePersonaData(userId),
    enabled: !!userId && !!zorId,
    retry: false,
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
